import { useEffect } from 'react';
import { initMetaPixel } from '@/analytics/metaPixel';
import { useTrackingConsent } from '@/analytics/consent';

export function MetaPixel() {
  const consent = useTrackingConsent();

  useEffect(() => {
    if (consent === 'granted') initMetaPixel();
  }, [consent]);

  return null;
}
